import React, { useEffect, useState, useRef } from "react";
import * as XLSX from "xlsx";
import Select from "react-select";

import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import Header from '../components/header';
import Chart from "../components/chart";

function Repair() {
  const [data, setData] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const navigate = useNavigate(); // ใช้ navigate() สำหรับเปลี่ยนหน้า

  const tableRef = useRef(null);
  const [user, setUser] = useState(null);
  const [file, setFile] = useState(null);

  // Select users
  const [selectedUserOption, setSelectedUserOption] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [employeeCount, setEmployeeCount] = useState(0);
  const [userSearchInput, setUserSearchInput] = useState("");
  
  // const [selectedDate, setSelectedDate] = useState("");
  const dateInputRef = useRef(null);

  const [filteredData, setFilteredData] = useState([]);

  const [selectedFilter, setSelectedFilter] = useState(""); // สำหรับเก็บสถานะที่เลือก
  const [selectedType, setSelectedType] = useState("");

  const [dateRange, setDateRange] = useState([null, null]); // สำหรับเก็บช่วงวันที่ที่เลือก

  const [statusCounts, setStatusCounts] = useState({});
  const [totalCount, setTotalCount] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [searchQuery, setSearchQuery] = useState(''); // สำหรับเก็บคำค้นหา

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [status, setStatus] = useState(""); // สถานะของรายการ
  const [loading, setLoading] = useState(false);

  const [dateValues, setDateValues] = useState({});

  const [objectValues, setObjectValues] = useState({});
  const [objectSaveMessage, setObjectSaveMessage] = useState({});

  const [adminEditMode, setAdminEditMode] = useState({});
  const [adminValues, setAdminValues] = useState({});
  const [adminSaveMessage, setAdminSaveMessage] = useState({});
  const adminTextareaRefs = useRef({});

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile) {
      const fileURL = URL.createObjectURL(droppedFile);
      setFile({ 
        name: droppedFile.name, 
        url: fileURL, 
        type: droppedFile.type, 
        size: (droppedFile.size / 1024).toFixed(2) 
      });
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

// ตั้งค่า Flatpickr
useEffect(() => {
  if (window.flatpickr) {
    window.flatpickr("#dateRangePicker", {
      mode: "range",
      dateFormat: "Y-m-d",
      onChange: function (selectedDates, dateStr) {
        const dates = dateStr.split(" to ");
        setDateRange(dates.length === 2 ? dates : ["", ""]);
      },
    });
  }
}, []);

// กรองข้อมูลตามช่วงวันที่
useEffect(() => {
  const filtered = data.filter((item) => {
    const itemDate = new Date(item.list_date);
    const fromDate = new Date(dateRange[0]);
    const toDate = new Date(dateRange[1]);
    return itemDate >= fromDate && itemDate <= toDate;
  });
  setFilteredData(filtered);
}, [data, dateRange]);

 // ฟังก์ชันกรองข้อมูลตามสถานะ
useEffect(() => {
  const filtered = filteredData.filter((item) => {
    if (selectedFilter) {
      return item.list_status === selectedFilter;
    }
    return true; // ถ้าไม่เลือกกรองแสดงทั้งหมด
  });
  setFilteredData(filtered);
}, [selectedFilter, data, dateRange]);

 // ฟังก์ชันในการส่งออก Excel
 const exportToExcel = () => {
  const ws = XLSX.utils.json_to_sheet(filteredData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, "data.xlsx");
};

  useEffect(() => {
    if (dateInputRef.current && window.flatpickr) {
      window.flatpickr(dateInputRef.current, {
        dateFormat: "Y-m-d",
        allowInput: true,
        onChange: (selectedDates, dateStr) => {
          setSelectedDate(dateStr);
          if (tableRef.current) {
            tableRef.current.search(dateStr).draw();
          }
        },
      });
    }
  }, []);

  // date selector
  const [reportCounts, setReportCounts] = useState({
    Total: 0,
    Success: 0,
    Processing: 0,
    Cancel: 0
  });

  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    const domain = "software.piyamanee.com";
    // const domain = "localhost";

    const fetchData = () => {
      const formattedDate = selectedDate.toISOString().split("T")[0];

      fetch(`https://${domain}/server/fetch/loadListDashboard.php?date=${formattedDate}`)
      // fetch(`http://${domain}/user_repairs_old/user_repairs/server/fetch/loadListDashboard.php?date=${formattedDate}`)
        .then((response) => response.json())
        .then((data) => {
          if (data && typeof data === "object") {
            setReportCounts({
              Total: data.Total || 0,
              Success: data.Success || 0,
              Processing: data.Processing || 0,
              Cancel: data.Cancel || 0
            });
          } else {
            console.error("Invalid data format", data);
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    };

    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, [selectedDate]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      const fileURL = URL.createObjectURL(selectedFile);
      setFile({ 
        name: selectedFile.name, 
        url: fileURL, 
        type: selectedFile.type, 
        size: (selectedFile.size / 1024).toFixed(2) 
      });
    } else {
      setFile(null);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (error) {
        console.error('Error parsing user data from localStorage', error);
        setUser(null); 
      }
    } else {
      setUser(null);
    }
  }, []); 

  const fetchData = async () => {
    try {
      //  const domain = "localhost";
      const domain = "software.piyamanee.com";
      let url = `https://${domain}/server/fetch/loadList.php`;
      // let url = `http://${domain}/user_repairs_old/user_repairs/server/fetch/loadList.php`;

      const params = new URLSearchParams();
      if (dateRange?.[0] && dateRange?.[1]) {
        params.append("fromDate", dateRange[0]);
        params.append("toDate", dateRange[1]);
      }
      if (selectedFilter) {
        params.append("status", selectedFilter);
      }
      if (selectedType) {
        params.append("type", selectedType);
      }
      params.append("page", currentPage);
  
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
  
      const response = await fetch(url);
      const result = await response.json();
  
      setData(result.data);
      setStatusCounts(result.statusCounts || {});
      setTotalPages(result.totalPages);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };  

  // // เอาไว้เรียกซ้ำหลัง updateStatus
  // const fetchData = async () => {
  //   try {
  //     // const domain = "localhost";
  //     const domain = "software.piyamanee.com";
  //     let url = `https://${domain}/server/fetch/loadList.php`;
  //     // let url = `http://${domain}/user_repairs_old/user_repairs/server/fetch/loadList.php`;

  //     const params = new URLSearchParams();
  //     if (dateRange?.[0] && dateRange?.[1]) {
  //       params.append("fromDate", dateRange[0]);
  //       params.append("toDate", dateRange[1]);
  //     }
  //     if (selectedFilter) {
  //       params.append("status", selectedFilter);
  //     }
  //     params.append("page", currentPage);

  //     if (params.toString()) {
  //       url += `?${params.toString()}`;
  //     }

  //     const response = await fetch(url);
  //     const result = await response.json();

  //     setData(result.data);
  //     setStatusCounts(result.statusCounts || {});
  //     setTotalPages(result.totalPages);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // รันตอนโหลดครั้งแรก และเวลามี filter/page เปลี่ยน
  useEffect(() => {
    fetchData();
  }, [dateRange, selectedFilter, selectedType, currentPage]);  

  useEffect(() => {
    if (data.length > 0) {
      const initialObjectValues = {};
      const initialAdminValues = {};

      data.forEach(item => {
        initialObjectValues[item.list_id_type] = item.list_object || "";
        initialAdminValues[item.list_id_type] = item.list_admin || "";
      });

      setObjectValues(initialObjectValues);
      setAdminValues(initialAdminValues);
    }
  }, [data]);

  // เรียกตอนกดอัปเดตสถานะ
  const updateStatus = async (newStatus, id) => {
    if (loading) return;
    setLoading(true);
  
    try {
      const domain = "software.piyamanee.com";
      const response = await fetch(`https://${domain}/server/update/updateStatus.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, status: newStatus }),
      });
  
      const result = await response.json();
  
      if (result.success) {
        setData(prevData =>
          prevData.map(item =>
            item.list_id_type === id
              ? { ...item, list_status: newStatus }
              : item
          )
        );
      } else {
        alert("❌ อัปเดตไม่สำเร็จ: " + result.message);
      }
    } catch (error) {
      console.error("❌ Error:", error);
      alert("❌ เกิดข้อผิดพลาดในการอัปเดต");
    } finally {
      setLoading(false);
    }
  };  

  const API_DOMAIN = "software.piyamanee.com";
  // const API_DOMAIN = "localhost";
  // const API_BASE = `http://${API_DOMAIN}/user_repairs_old/user_repairs`; 
  const API_BASE = `https://${API_DOMAIN}`; 

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await fetch(`${API_BASE}/server/fetch/loadEmployees.php`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        console.log("Employees API:", result);

        setEmployeeCount(result.count || 0);
        setUserOptions(result.employees || []);
      } catch (error) {
        console.error("โหลดรายชื่อพนักงานไม่สำเร็จ:", error);
      }
    };

    fetchEmployees();
  }, []);

  const filteredUserOptions = userOptions
	.map((group) => {
		const filteredOptions = group.options.filter((option) => {
			const keyword = userSearchInput.toLowerCase().trim();
			return option.label.toLowerCase().includes(keyword);
		});

		return {
			...group,
			label: `${group.label} (${filteredOptions.length} คน)`,
			options: filteredOptions
		};
	})
	.filter((group) => group.options.length > 0);

  const handleChangeObject = (id, value) => {
    setObjectValues(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleChangeAdmin = (id, value) => {
    setAdminValues(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const updateObject = async (id) => {
    if (loading) return;
    setLoading(true);

    const list_object = objectValues[id] || "";

    if (!list_object.trim()) {
      setObjectSaveMessage(prev => ({
        ...prev,
        [id]: { message: "❌ กรุณากรอกรหัสอุปกรณ์", type: "error" }
      }));

      setTimeout(() => {
        setObjectSaveMessage(prev => ({
          ...prev,
          [id]: null
        }));
      }, 3000);

      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`https://${API_DOMAIN}/server/update/updateObject.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id,
          list_object
        })
      });

      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }

      const result = await response.json();

      if (result.success) {
        setData(prevData =>
          prevData.map(item =>
            item.list_id_type === id
              ? { ...item, list_object }
              : item
          )
        );

        setObjectSaveMessage(prev => ({
          ...prev,
          [id]: { message: "✅ บันทึกรหัสอุปกรณ์เรียบร้อย", type: "success" }
        }));

        setTimeout(() => {
          setObjectSaveMessage(prev => ({
            ...prev,
            [id]: null
          }));
        }, 3000);

      } else {
        setObjectSaveMessage(prev => ({
          ...prev,
          [id]: { message: "❌ บันทึกไม่สำเร็จ: " + result.message, type: "error" }
        }));

        setTimeout(() => {
          setObjectSaveMessage(prev => ({
            ...prev,
            [id]: null
          }));
        }, 3000);
      }

    } catch (error) {
      console.error("❌ Error updateObject:", error);

      setObjectSaveMessage(prev => ({
        ...prev,
        [id]: { message: "❌ เกิดข้อผิดพลาด: " + error.message, type: "error" }
      }));

      setTimeout(() => {
        setObjectSaveMessage(prev => ({
          ...prev,
          [id]: null
        }));
      }, 3000);

    } finally {
      setLoading(false);
    }
  };

  const updateAdminNote = async (id) => {
  if (loading) return;
  setLoading(true);

  const list_admin = adminValues[id] || "";

  try {
    const response = await fetch(`https://${API_DOMAIN}/server/update/updateAdminNote.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        id,
        list_admin
      })
    });

    if (!response.ok) {
      throw new Error(`Server error: ${response.status}`);
    }

    const result = await response.json();

    if (result.success) {
      setData(prevData =>
        prevData.map(item =>
          item.list_id_type === id
            ? { ...item, list_admin }
            : item
        )
      );

      setAdminSaveMessage(prev => ({
        ...prev,
        [id]: { message: "✅ บันทึกรายละเอียดเรียบร้อย", type: "success" }
      }));

      setAdminEditMode(prev => ({
        ...prev,
        [id]: false
      }));

      setTimeout(() => {
        setAdminSaveMessage(prev => ({
          ...prev,
          [id]: null
        }));
      }, 3000);

    } else {
      setAdminSaveMessage(prev => ({
        ...prev,
        [id]: { message: "❌ บันทึกไม่สำเร็จ: " + result.message, type: "error" }
      }));

      setTimeout(() => {
        setAdminSaveMessage(prev => ({
          ...prev,
          [id]: null
        }));
      }, 3000);
    }

  } catch (error) {
    console.error("❌ Error updateAdminNote:", error);

    setAdminSaveMessage(prev => ({
      ...prev,
      [id]: { message: "❌ เกิดข้อผิดพลาด: " + error.message, type: "error" }
    }));

    setTimeout(() => {
      setAdminSaveMessage(prev => ({
        ...prev,
        [id]: null
      }));
    }, 3000);

  } finally {
    setLoading(false);
  }
  };

  // เมื่อ input เปลี่ยนค่า
  const handleChangeDate = (id, field, value) => {
    setDateValues(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value
      }
    }));
  };

  // ตัวอย่างเปิด modal preload ค่าเดิม
  const handleOpenModal = (item) => {
    setDateValues(prev => ({
      ...prev,
      [item.list_id_type]: {
        start: item.list_start || "",
        end: item.list_end || ""
      }
    }));
  };

  // --- Edit Type (งานช่าง / IT / Programmer) state and handlers ---
  const [typeEditValues, setTypeEditValues] = useState({});
  const [updateTypeMessage, setUpdateTypeMessage] = useState({});

  const handleOpenTypeModal = (item) => {
    setTypeEditValues(prev => ({
      ...prev,
      [item.list_id_type]: item.list_type || ""
    }));
    setUpdateTypeMessage(prev => ({ ...prev, [item.list_id_type]: undefined }));
  };

  const handleChangeType = (id, value) => {
    setTypeEditValues(prev => ({ ...prev, [id]: value }));
  };

  const updateType = async (id) => {
    try {
      const newType = typeEditValues[id];
      // optimistic update locally
      setData(prev => prev.map(d => (d.list_id_type === id ? { ...d, list_type: newType } : d)));

      // try to persist to backend if API available
      const domain = API_DOMAIN;
      const url = `https://${domain}/server/update/updateType.php`;
      // const url = `http://${domain}/user_repairs_old/user_repairs/server/update/updateType.php`;
      const form = new URLSearchParams();
      form.append('list_id_type', id);
      form.append('list_type', newType);

      const res = await fetch(url, {
        method: 'POST',
        body: form
      }).catch(() => null);

      if (res) {
        const text = await res.text();
        // If backend returns JSON with success flag you can parse it here.
        setUpdateTypeMessage(prev => ({ ...prev, [id]: { message: 'อัพเดทประเภทงานเรียบร้อย', type: 'success' } }));
      } else {
        setUpdateTypeMessage(prev => ({ ...prev, [id]: { message: 'ไม่สามารถติดต่อเซิร์ฟเวอร์ได้ (local update สำเร็จ)', type: 'warning' } }));
      }

      // hide modal (if bootstrap available)
      try {
        const modalEl = document.getElementById(`editTypeModal_${id}`);
        if (modalEl) {
          const bsModal = window.bootstrap?.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
          bsModal.hide();
        }
      } catch (e) {
        // ignore
      }
    } catch (error) {
      setUpdateTypeMessage(prev => ({ ...prev, [id]: { message: 'เกิดข้อผิดพลาดระหว่างอัพเดท', type: 'error' } }));
      console.error('updateType error', error);
    }
  };

  // update list start end
  const [updateStatusMessage, setUpdateStatusMessage] = useState({}); // { [id]: { message: "", type: "success"|"error" } }

  const updateDate = async (id) => {
    if (loading) return;
    setLoading(true);

    const { start, end } = dateValues[id] || { start: "", end: "" };

    try {
      // const response = await fetch(`https://${API_DOMAIN}/user_repairs_old/user_repairs/server/update/updateDate.php`, {
      const response = await fetch(`https://${API_DOMAIN}/server/update/updateDate.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id, start, end }),
      });

      if (!response.ok) throw new Error(`Server error: ${response.status}`);

      const result = await response.json();

      if (result.success) {
        setData(prevData =>
          prevData.map(item =>
            item.list_id_type === id
              ? { ...item, list_start: start, list_end: end }
              : item
          )
        );
        setUpdateStatusMessage(prev => ({
          ...prev,
          [id]: { message: "✅ วันที่อัปเดตสำเร็จ", type: "success" }
        }));
      } else {
        setUpdateStatusMessage(prev => ({
          ...prev,
          [id]: { message: "❌ ไม่สามารถอัปเดตวันที่ได้: " + result.message, type: "error" }
        }));
      }
    } catch (error) {
      console.error("❌ Error:", error);
      setUpdateStatusMessage(prev => ({
        ...prev,
        [id]: { message: "❌ เกิดข้อผิดพลาด: " + error.message, type: "error" }
      }));
    } finally {
      setLoading(false);
    }
  };
  // update list start end
  
  // ฟังก์ชันเปลี่ยนหน้า
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };  

  const handleExport = () => {
    // const domain = "localhost";
    const domain = "software.piyamanee.com";
    let url = `https://${domain}/server/fetch/loadList.php?export=true`;
    // let url = `http://${domain}/user_repairs_old/user_repairs/server/fetch/loadList.php?export=true`;
  
    const params = new URLSearchParams();
  
    if (dateRange?.[0] && dateRange?.[1]) {
      params.append("fromDate", dateRange[0]);
      params.append("toDate", dateRange[1]);
    }
  
    if (selectedFilter) {
      params.append("status", selectedFilter);
    }
  
    // เพิ่มกรองประเภท
    if (selectedType) {
      params.append("type", selectedType);
    }
  
    if (params.toString()) {
      url += `&${params.toString()}`;
    }
  
    // ทำการดาวน์โหลด Excel
    window.location.href = url;
  };
  

  const handleSearch = async () => {
    try {
      // const domain = "localhost"; // ใช้ domain ของคุณ
      const domain = "software.piyamanee.com";
      let url = `https://${domain}/server/fetch/loadList.php`;

      const params = new URLSearchParams();
      if (dateRange?.[0] && dateRange?.[1]) {
        params.append("fromDate", dateRange[0]);
        params.append("toDate", dateRange[1]);
      }
      if (selectedFilter) {
        params.append("status", selectedFilter);
      }
      if (searchQuery) {
        params.append("searchQuery", searchQuery); // ส่งคำค้นหาไปกับ URL
      }

      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await fetch(url);
      const result = await response.json();
      console.log("API Response:", result);

      setData(result.data);
      setStatusCounts(result.statusCounts || {});
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // ฟังก์ชันนี้จะถูกเรียกเมื่อ dateRange, selectedFilter หรือ searchQuery เปลี่ยน
  useEffect(() => {
    handleSearch();  // เรียกฟังก์ชันค้นหาทุกครั้งที่ค่าต่าง ๆ เปลี่ยนแปลง
  }, [dateRange, selectedFilter, searchQuery]);
  
  const handleDateChange = (event) => {
    const date = event.target.value;
    setSelectedDate(date);

    if (tableRef.current) {
      tableRef.current.search(date).draw();
    }
  };

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
    setCurrentPage(1); // รีเซ็ตหน้าเมื่อ filter เปลี่ยน
  };
  
  const handleSave = () => {
    const formData = new FormData();
  
    const listType = document.querySelector('select[name="list_type"]')?.value;
    const listReason = document.querySelector('input[name="list_reason"]')?.value;
    const listDate = document.querySelector('input[name="list_date"]')?.value;

    if (!selectedUserOption) {
      alert("❌ กรุณาเลือกผู้แจ้งงาน");
      return;
    }

    // const listUsername = document.querySelector('input[name="list_username"]')?.value;
    const listUsername = selectedUserOption?.value || "";

    const listCompany = document.querySelector('select[name="list_company"]')?.value;
    const listPhone = document.querySelector('input[name="list_phone"]')?.value;
    const listDepartment = document.querySelector('select[name="list_department"]')?.value;
    const listPosition = document.querySelector('select[name="list_position"]')?.value;
    const fileInput = document.querySelector('input[name="file"]');
    const domain = "software.piyamanee.com";
    // const domain = "localhost";

    if (!listType || !listReason || !listDate || !listUsername || !listCompany || !listPhone || !listDepartment || !listPosition) {
        alert('กรุณากรอกข้อมูลให้ครบทุกช่อง');
        return;
    }

    formData.append('list_type', listType);
    formData.append('list_reason', listReason);
    formData.append('list_date', listDate);
    formData.append('list_username', listUsername);
    formData.append('list_company', listCompany);
    formData.append('list_phone', listPhone);
    formData.append('list_department', listDepartment);
    formData.append('list_position', listPosition);

    if (fileInput && fileInput.files && fileInput.files.length > 0) {
        formData.append('file', fileInput.files[0]);
    }

    // แสดง spinner ก่อน 5 วินาที
    const loader = document.querySelector(".loader");
    loader.style.display = "flex";

    setTimeout(() => {
        fetch(`https://${domain}/server/form/intsData.php`, {
        // fetch(`http://${domain}/user_repairs_old/user_repairs/server/form/intsData.php`, {
            method: 'POST',
            body: formData,
        })
        .then(response => response.text())
        .then(text => {
            loader.style.display = "none";
            try {
                const data = JSON.parse(text);
                console.log("Received data:", data);  // ดูข้อมูลที่ได้รับจากเซิร์ฟเวอร์
                
                if (data.success) {
                    const alertSuccess = document.getElementById("alertSuccess");
                    if (alertSuccess) {
                        const listIdType = data.list_id_type || 'ไม่มีรหัส';  // ตรวจสอบว่าได้รับค่าจริงหรือไม่
                        alertSuccess.style.display = "block"; 
                        alertSuccess.innerHTML = `<i class='fa-solid fa-circle-check'></i> บันทึกข้อมูลเรียบร้อยแล้ว : รหัสของคุณ ${listIdType} เพื่อติดตามสถานะ`;

                        window.location.reload();

                        // เก็บสถานะการบันทึกสำเร็จใน localStorage
                        localStorage.setItem('isDataSaved', 'true');
                        localStorage.setItem('listIdType', listIdType);  // เก็บรหัส list_id_type

                    }
                } else {
                    alert('ไม่สามารถบันทึกข้อมูลได้: ' + (data.message || 'เกิดข้อผิดพลาด'));
                }
            } catch (error) {
                console.error("Response is not JSON:", text);
                alert("เกิดข้อผิดพลาด: Response ไม่ใช่ JSON");
            }
        })
        .catch(error => {
            loader.style.display = "none";
            console.error('Error:', error);
            alert('เกิดข้อผิดพลาดในการส่งข้อมูล: ' + error.message);
        });
    }, 5000);
  };

  useEffect(() => {
    // เมื่อหน้าโหลดใหม่, เช็คว่าเคยบันทึกข้อมูลสำเร็จหรือไม่
    const isDataSaved = localStorage.getItem('isDataSaved');
    const listIdType = localStorage.getItem('listIdType');  // ดึง list_id_type จาก localStorage

    if (isDataSaved && listIdType) {
        // หากบันทึกสำเร็จ, แสดงข้อความ
        const alertSuccess = document.getElementById("alertSuccess");
        if (alertSuccess) {
            alertSuccess.style.display = "block"; 
            alertSuccess.innerHTML = `<i class='fa-solid fa-circle-check'></i> บันทึกข้อมูลเรียบร้อยแล้ว : รหัสของคุณ ${listIdType} เพื่อติดตามสถานะ`;

            // setTimeout(() => {
            //     alertSuccess.style.opacity = 0;
            //     alertSuccess.style.transition = "opacity 1s ease-out";
            // }, 4000);

            localStorage.removeItem('isDataSaved');
            localStorage.removeItem('listIdType');  // ลบ list_id_type หลังจากแสดงผล
        }
    }
  }, []);

  return (

    <main>
        <Header/>

        <div className='indexMain_ContentArea_Container' style={{marginTop: "90px"}}>

          {/* {user ? (
            <div></div>
          ) : (
            <div className="inCaseIndex_info">
              <span><i className="fa-solid fa-circle-info" style={{color: "orange"}}></i> สำหรับพนักงานที่มีรหัสเท่านั้น </span>
            </div>
          )} */}

          <div className={user ? "" : "userBlockIndicators"}>
            <span className="blinking-dot">●</span>
            <span style={{fontSize: "14px"}}> อัพเดททุก 10 วินาที </span>
          </div>

                {user ? (
                  <div style={{
                  margin:"15px 0",
                  backgroundColor:"white",
                  padding:"5px 22px",
                  marginBottom:"0px",
                  borderRadius:"8px",
                  boxShadow:"0px 5px 10px #00000008",
                  fontSize:"15px",
                  display:"flex",
                  justifyContent:"space-between",
                  alignItems:"center"
                  }} className='indexMain_ContentArea_Container indexMobilesPrevNext'>
                    <div>
                      <span><i className="fa-solid fa-clock"></i>  สรุปแบบรายวัน</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      className="btnDatePrev"
                      onClick={() =>
                        setSelectedDate(prev => {
                          const newDate = new Date(prev);
                          newDate.setDate(newDate.getDate() - 1);
                          return newDate;
                        })
                      }
                    >
                      <i className="fa-solid fa-caret-left"></i> ก่อน
                    </button>

                    <div style={{ color: "gray", margin: "0 10px", fontSize: "14px" }}>
                      {selectedDate.toLocaleDateString("th-TH", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric"
                      })}
                    </div>

                    <button
                      className="btnDateNext"
                      onClick={() =>
                        setSelectedDate(prev => {
                          const newDate = new Date(prev);
                          newDate.setDate(newDate.getDate() + 1);
                          return newDate;
                        })
                      }
                    >
                      หลัง <i className="fa-solid fa-caret-right"></i>
                    </button>
                  </div>
                </div>
                ) : (
                  <div></div>
                )}

          

          <div className={user ? "indexReport_Container" : "indexReport_Container userBlockIndicators"}>
            <div className="indexReportBox case_todyBg">
              <h3><i class="fa-solid fa-calendar-day"></i> ทั้งหมด</h3>
              <div className="indexReportCounts">{reportCounts.Total}</div>
            </div>
            <div className="indexReportBox case_alreadyBg">
              <h3><i className="fa-solid fa-circle-check"></i> เรียบร้อยแล้ว</h3>
              <div className="indexReportCounts case_already">{reportCounts.Success}</div>
            </div>
            <div className="indexReportBox case_processBg">
              <h3><i className="fa-solid fa-person-running"></i> กำลังดำเนินการ</h3>
              <div className="indexReportCounts case_process">{reportCounts.Processing}</div>
            </div>
            <div className="indexReportBox case_cancelBg">
              <h3><i className="fa-solid fa-ban"></i> ยกเลิก</h3>
              <div className="indexReportCounts case_cancel">{reportCounts.Cancel}</div>
            </div>
            <div style={{color:"gray" , fontSize:"13px"}}>
              <i class="fa-solid fa-circle-exclamation"></i> Last update v.26.3 : 27-03-2026 - 11.32
            </div>
          </div>

          {/* <Chart/> */}

          <div className={user ? "indexMain_top" : "noflexUsers"}>

            <div className={user ? "indexMain_heading" : "indexMain_heading userBlockIndicators"}><i class="fa-solid fa-gears"></i> รายการแจ้งซ่อม </div>
            <div className='indexMain_heading'>
              {/* Button trigger modal */}

              {user ? (
                <div>
                  <button type="button" className={user ? "btn btnAddListeners" : "btn btnAddListeners userBtuttonAllow"} data-bs-toggle="modal" data-bs-target="#exampleModal">
                  <i class="fa-solid fa-plus"></i> แจ้งซ่อม
                </button>
              </div>
              ) : (
                <div></div>
              )}

              {/* Modal */}
              <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h3 className="modal-title fs-5" id="exampleModalLabel"><i class="fa-solid fa-user-plus"></i> เพิ่มรายการแจ้งซ่อม</h3>
                      <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                      
                      <div className='modalBox_load'>

                          <div className='row externalMargin' style={{ marginBottom: "5px" }}>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-box"></i> ประเภทงานที่แจ้งซ่อม </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <select className='form-select' style={{fontSize: "14px"}} name='list_type'>
                                <option value="1">งานช่าง</option>
                                <option value="2">IT Support</option>
                                <option value="3">Programmer</option>
                              </select>
                            </div>
                          </div>

                          <div className="row externalMargin">
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-circle-question"></i> ปัญหา </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <input className='form-control' placeholder='ระบุ' name='list_reason' />
                              {/* <textarea className='form-control' placeholder='ระบุ' name='list_reason' style={{minHeight: "150px"}}></textarea> */}
                            </div>
                          </div>

                          <div className='row externalMargin'>
                            <div>
                              <h5 style={{ fontSize: '14px' }}>ให้แนบรูปที่เกี่ยวข้อง</h5>
                              <span style={{ fontSize: '13px' }}>
                                <i className="fa-solid fa-file"></i> อัพโหลดไฟล์
                              </span>{' '}
                              <span style={{ color: 'gray', fontSize: '13px' }}>(ไม่จำเป็น)</span> <span style={{ color: '#0d83e5', fontSize: '13px' }}>อัพโหลดได้ 1 รูปเท่านั้น</span>

                              {/* Drag & Drop Zone */}
                              <div
                                onClick={() => document.getElementById('formFileSm').click()}
                                onDragOver={handleDragOver}
                                onDrop={handleDrop}
                                className='dropFilesArea'
                              >
                                {file ? (
                                  file.type.startsWith('image/') ? (
                                    <img
                                      src={file.url}
                                      alt="อัพโหลดแล้ว"
                                      style={{ width: '100%', marginTop: '0px' }}
                                    />
                                  ) : (
                                    <p>ไฟล์ที่เลือก: {file.name}</p>
                                  )
                                ) : (
                                  <div style={{marginBottom:"0px",fontSize:"13px",color:"gray"}}><i class="fa-solid fa-cloud-arrow-up"></i> ลากไฟล์มาวางที่นี่ หรือคลิกเพื่ออัพโหลด</div>
                                )}
                              </div>

                              {/* Hidden File Input */}
                              <input
                                type="file"
                                id="formFileSm"
                                name="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                              />

                              {/* File Size */}
                              {file && (
                                <div id="fileSize" style={{ marginTop: '10px' }}>
                                  <span>ขนาดไฟล์: {file.size} KB</span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className='row externalMargin'>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-calendar"></i> วันที่แจ้ง </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <input type='date' className='form-control' name='list_date' />
                            </div>
<div className='col'>
	<div style={{ marginBottom: "10px" }}>
		<span><i className="fa-solid fa-user"></i> ชื่อ - สกุล</span>
		<span style={{ color: "red" }}> * </span>
		<span>ผู้แจ้ง</span>
		{/* <span style={{ color: "#666", marginLeft: "8px", fontSize: "12px" }}>
			(ทั้งหมด {employeeCount} คน)
		</span> */}
	</div>

<Select
	options={filteredUserOptions}
	value={selectedUserOption}
	onChange={(selected) => setSelectedUserOption(selected)}
	onInputChange={(inputValue, actionMeta) => {
		if (actionMeta.action === "input-change") {
			setUserSearchInput(inputValue);
		}
		if (actionMeta.action === "menu-close") {
			setUserSearchInput("");
		}
	}}
	placeholder="ค้นหา หรือ เลือกชื่อผู้แจ้งงาน"
	isSearchable={true}
	isClearable={true}
	noOptionsMessage={() => "ไม่พบรายชื่อ"}
	classNamePrefix="react-select"
	filterOption={null}
	formatGroupLabel={(group) => (
		<div
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center"
			}}
		>
			<span>{group.label}</span>
			<span
				style={{
					background: "#e5e7eb",
					borderRadius: "999px",
					padding: "2px 8px",
					fontSize: "11px",
					fontWeight: "600",
					color: "#374151"
				}}
			>
				{group.options.length} คน
			</span>
		</div>
	)}
	styles={{
		control: (base, state) => ({
			...base,
			minHeight: "38px",
			borderRadius: "0.375rem",
			borderColor: !selectedUserOption
				? "#dc3545"
				: state.isFocused
				? "#86b7fe"
				: "#ced4da",
			boxShadow: state.isFocused
				? "0 0 0 0.2rem rgba(13,110,253,.25)"
				: "none",
			"&:hover": {
				borderColor: !selectedUserOption
					? "#dc3545"
					: state.isFocused
					? "#86b7fe"
					: "#ced4da"
			}
		}),
		menu: (base) => ({
			...base,
			zIndex: 9999
		}),
		groupHeading: (base) => ({
			...base,
			fontWeight: "700",
			fontSize: "13px",
			color: "#111827",
			backgroundColor: "#f3f4f6",
			padding: "8px 12px",
			marginBottom: "4px",
			borderRadius: "6px"
		}),
		option: (base, state) => ({
			...base,
			backgroundColor: state.isFocused ? "#f3f4f6" : "#fff",
			color: "#111827",
			padding: "10px 12px",
			cursor: "pointer"
		}),
		placeholder: (base) => ({
			...base,
			color: "#9ca3af"
		})
	}}
/>

  <div style={{ marginTop: "10px" , color: "red" , fontSize: "12px" }}><i class="fa-solid fa-circle-info"></i> กรุณาเลือกให้ตรงตามความจริง </div>
</div>
                          </div>

                          <div className='row externalMargin'>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-building-user"></i> บริษัท </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <select id="" name="list_company" className="form-select" style={{fontSize: "14px"}}>
                                  <option value="บริษัท อนุสรณ์ เบสเซฟ จำกัด">บริษัท อนุสรณ์ เบสเซฟ จำกัด</option>
                                  <option value="หจก.ปิยะมณี เอ็กซ์พอร์ต แอนด์ อิมพอร์ต">หจก.ปิยะมณี เอ็กซ์พอร์ต แอนด์ อิมพอร์ต</option>

                                  <option value="บจก.ปิยะมณี อพาร์ทเม้นท์ (บ้านค่าย) จำกัด (สำนักงานใหญ่)">บจก.ปิยะมณี อพาร์ทเม้นท์ (บ้านค่าย) จำกัด (สำนักงานใหญ่)</option>
                                  <option value="บจก.ปิยะมณี อพาร์ทเม้นท์ (ทับมา) จำกัด (สำนักงานใหญ่)">บจก.ปิยะมณี อพาร์ทเม้นท์ (ทับมา) จำกัด (สำนักงานใหญ่)</option>
                                  <option value="บจก.ปิยะมณี อพาร์ทเม้นท์ (มาบตาพุด) จำกัด (สำนักงานใหญ่)">บจก.ปิยะมณี อพาร์ทเม้นท์ (มาบตาพุด) จำกัด (สำนักงานใหญ่)</option>
                                  <option value="บจก.ปิยะมณี แลนด์แอนด์เฮาส์">บจก.ปิยะมณี แลนด์แอนด์เฮาส์</option>

                                  <option value="บริษัท หยกมณี อินเตอร์เนชั่นแนล จำกัด">บริษัท หยกมณี อินเตอร์เนชั่นแนล จำกัด</option>
                                  <option value="บริษัท ปิยะมณี กรุ๊ป อินเตอร์เนชั่นแนล จำกัด">บริษัท ปิยะมณี กรุ๊ป อินเตอร์เนชั่นแนล จำกัด</option>
                                  <option value="บริษัท ปิยะมณี เซอร์วิส จำกัด">บริษัท ปิยะมณี เซอร์วิส จำกัด</option>
                                  <option value="บริษัท ปิยะมณี กรุ๊ป จำกัด">บริษัท ปิยะมณี กรุ๊ป จำกัด</option>
                                  <option value="หจก. อนุสรณ์ โปรดักส์">หจก. อนุสรณ์ โปรดักส์</option>
                              </select>
                            </div>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-phone"></i> เบอร์โทรศัพท์ </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <input className='form-control' placeholder='ระบุ' name='list_phone' />
                            </div>
                          </div>

                          <div className='row externalMargin'>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-calendar"></i> แผนก </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <select id="" name="list_department" className="form-select" style={{fontSize: "14px"}}>
                                <option value="ความปลอดภัยและทรัพยากรมนุษย์">แผนก: ความปลอดภัยและทรัพยากรมนุษย์</option>
                                <option value="ที่ปรึกษา - เลขานุการ">แผนก: ที่ปรึกษา - เลขานุการ</option>
                                <option value="พัฒนาระบบ">แผนก: พัฒนาระบบ</option>
                                <option value="บัญชี">แผนก: บัญชี</option>
                                <option value="การเงิน">แผนก: การเงิน</option>
                                <option value="จัดซื้อ">แผนก: จัดซื้อ</option>
                                <option value="การตลาด">แผนก: การตลาด</option>
                                <option value="ฝ่ายผลิต">แผนก: ฝ่ายผลิต</option>
                                <option value="IT">แผนก: IT</option>
                                <option value="ช่าง">แผนก: ช่าง</option>
                                <option value="คลังสินค้า (สโตร์)">แผนก: คลังสินค้า (สโตร์)</option>
                                <option value="จัดส่ง">แผนก: จัดส่ง</option>
                                <option value="ปรุงอาหาร">แผนก: ปรุงอาหาร</option>
                                <option value="ขาย (Sales)">แผนก: ขาย (Sales)</option>
                                <option value="หจก. อนุสรณ์ โปรดักส์">หจก. อนุสรณ์ โปรดักส์</option>
                              </select>
                            </div>
                            <div className='col'>
                              <div style={{marginBottom:"10px"}}>
                                <span><i class="fa-solid fa-box"></i> ตำแหน่ง </span>
                                <span style={{color:"red"}}> * </span>
                              </div>
                              <select id="" name="list_position" className="form-select" style={{fontSize: "14px"}}>
                                <option value="กรรมการผู้จัดการ">กรรมการผู้จัดการ (Director)</option>
                                <option value="กรรมการผู้จัดการทั่วไป">กรรมการผู้จัดการทั่วไป (General Manager)</option>
                                <option value="เลขาผู้บริหาร">เลขาผู้บริหาร (Excutive Secretary)</option>
                                <option value="ที่ปรึกษา">ที่ปรึกษา</option>
                                <option value="ผู้จัดการฝ่าย">ผู้จัดการฝ่าย (Chief Manager Department)</option>
                                <option value="ผู้ช่วยผู้จัดการฝ่าย">ผู้ช่วยผู้จัดการฝ่าย (Senior Manager Section)</option>
                                <option value="ผู้จัดการแผนก">ผู้จัดการแผนก (Manager Section)</option>
                                <option value="ผู้ช่วยผู้จัดการแผนก">ผู้ช่วยผู้จัดการแผนก (Assistant Manager Section)</option>
                                <option value="หัวหน้าแผนกอาวุโส">หัวหน้าแผนกอาวุโส (Senior Supervisor)</option>
                                <option value="หัวหน้าแผนก">หัวหน้าแผนก (Supervisor)</option>
                                <option value="ผู้ช่วยหัวหน้าแผนก">ผู้ช่วยหัวหน้าแผนก (Assistant Supervisor)</option>
                                <option value="หัวหน้างาน">หัวหน้างาน (Leader)</option>
                                <option value="เจ้าหน้าที่ปฎิบัติงาน">เจ้าหน้าที่ปฎิบัติงาน (Opertaor) สำหรับฝ่ายผลิต</option>
                                <option value="พนักงานปฏิบัติการ">พนักงานปฏิบัติการ (Staff) สำหรับพนักงานสำนักงาน</option>
                                <option value="เจ้าหน้าที่ซ่อมบำรุงเครืองจักร">เจ้าหน้าที่ซ่อมบำรุงเครืองจักร (Machine Maintenance Staff)</option>
                                <option value="ช่างซ่อมบำรุงทั่วไป">ช่างซ่อมบำรุงทั่วไป (Maintenance & Repair Technician Staff)</option>
                                <option value="พนักงานปฎิบัติงานอาวุโส">พนักงานปฎิบัติงานอาวุโส (Senior Staff)</option>
                                <option value="เจ้าหน้าที่ความปลอดภัย">เจ้าหน้าที่ความปลอดภัย (Safety Officer)</option>
                                <option value="เจ้าหน้าที่สิ่งแวดล้อม">เจ้าหน้าที่สิ่งแวดล้อม (Environmental Officer)</option>
                                <option value="หัวหน้าฝ่ายขาย">หัวหน้าฝ่ายขาย (Sales Executive Supervisor)</option>
                                <option value="พนักงานฝ่ายขายอาวุโส">พนักงานฝ่ายขายอาวุโส (Senior Sales Executive)</option>
                                <option value="พนักงานฝ่ายขาย">พนักงานฝ่ายขาย (Sales Executive)</option>
                                <option value="เจ้าหน้าที่ประสานงานขายอาวุโส">เจ้าหน้าที่ประสานงานขายอาวุโส (Senior Sales Coordinator)</option>
                                <option value="เจ้าหน้าที่ประสานงานขาย">เจ้าหน้าที่ประสานงานขาย (Sales Coordinator)</option>
                                <option value="พนักงานทำความสะอาด">พนักงานทำความสะอาด (Housekeeper)</option>
                                <option value="พนักงานควบคุมเอกสาร">พนักงานควบคุมเอกสาร (Document Controller Officer)</option>
                                <option value="พนักงานฝ่ายบริการลูกค้า">พนักงานฝ่ายบริการลูกค้า (Customer Services Officer)</option>
                                <option value="หัวหน้าฝ่ายขายด้านเทคนิค">หัวหน้าฝ่ายขายด้านเทคนิค (Sales Executive Technician Supervisor)</option>
                                <option value="พนักงานฝ่ายขายด้านเทคนิคอาวุโส">พนักงานฝ่ายขายด้านเทคนิคอาวุโส (Senior Sales Executive Technician)</option>
                                <option value="พนักงานฝ่ายขายด้านเทคนิค">พนักงานฝ่ายขายด้านเทคนิค (Sales Executive Technician)</option>
                                <option value="เจ้าหน้าที่บริการด้านเทคนิค">เจ้าหน้าที่บริการด้านเทคนิค (Service Technician Officer)</option>
                                <option value="พนักงานส่งเสริมการลงทุน">พนักงานส่งเสริมการลงทุน (BOI Staff)</option>
                              </select>
                            </div>
                          </div>

                      </div>

                    </div>
                    <div className="modal-footer">
                      <div className="modalAlertBottom">
                        <i class="fa-solid fa-circle-exclamation"></i> โปรดตรวจสอบความถูกต้องก่อนบันทึกข้อมูล
                      </div>                        
                      <div className="footerButton">
                        <button type="button" style={{fontSize: "13px"}} className="btn" data-bs-dismiss="modal"><i class="fa-solid fa-circle-xmark"></i> ปิด</button>
                        <button type="button" style={{fontSize: "13px"}} className="btn btn-primary btnMobile" onClick={handleSave}><i className="fa-solid fa-upload"></i> บันทึก และออก</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div>
            <div className={`${!user ? "dateListSelectorList userOnly" : "dateListSelectorList"}`}>
              <div className="inputSelectors" style={{ marginRight: "10px" }}>
                <p>
                  <i className="fa-solid fa-calendar"></i> เลือกช่วงวันที่
                </p>
                <input
                  type="text"
                  id="dateRangePicker"
                  className="form-control"
                  placeholder="เลือกช่วงวันที่"
                  style={{ fontSize: "14px" , width: "200px" , textAlign: "center" }}
                  onChange={(e) => setDateRange(e.target.value.split(","))}
                />
              </div>

              <div style={{ marginRight: "10px" }} className="inputSelectors">
                <p>
                  <i className="fa-solid fa-filter"></i> กรองรายการ
                </p>
                <select className="indexFilterList" value={selectedFilter} onChange={handleFilterChange}>
                  <option value="">-- ทั้งหมด --</option>
                  <option value="Waiting">กำลังรอ ({statusCounts["Waiting"] || 0})</option>
                  <option value="Success">เรียบร้อยแล้ว ({statusCounts["Success"] || 0})</option>
                  <option value="Processing">กำลังดำเนินการ ({statusCounts["Processing"] || 0})</option>
                  <option value="Cancel">ยกเลิก ({statusCounts["Cancel"] || 0})</option>
                </select>
              </div>

              <div style={{ marginRight: "10px" }} className="inputSelectors">
                <p>
                  <i class="fa-solid fa-gears"></i> ประเภท
                </p>
                <select className="indexFilterList" value={selectedType} onChange={handleTypeChange}>
                  <option value="">-- ทั้งหมด --</option>
                  <option value="1">งานช่าง</option>
                  <option value="2">IT support</option>
                  <option value="3"> Programmer</option>
                </select>
              </div>

                {user ? (
                  <div style={{marginRight: "0px" , display: "flex" , alignItems: "end"}} className="export">
                    <div>
                      <p><i class="fa-solid fa-file-csv" style={{color: "green"}}></i> ส่งออกข้อมูล</p>
                      <select className='indexFilterList'>
                        <option value=''>Excel</option>
                      </select>
                    </div>
                    <button className="exportButtonList" onClick={handleExport}>
                      <i className="fa-solid fa-download"></i> Export
                    </button>
                  </div>
                ) : (
                  <div></div>
                )}

            </div>

            {/* <div className="alert alert-primary" style={{ fontSize: "14px" }} role="alert">
              <i class="fa-brands fa-line"></i> ระบบแจ้งเตือนไลน์ อยู่ระหว่างดำเนินการ

              <button type="button" class="btn btn-primary" style={{fontSize: "13px" , marginLeft: "10px"}} data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                API Usage Limits?
              </button>

              <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h1 class="modal-title fs-5" id="staticBackdropLabel" style={{color: "black"}}>เหตุผลที่ต้องมี API Usage Limits</h1>
                      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div style={{padding: "15px" , color: "black" , fontWeight: "500" , fontSize: "14px"}}>
                        การจำกัดจำนวนการเรียกใช้งาน (requests) หรือการส่งข้อความ ที่ผู้ใช้สามารถทำได้ภายในระยะเวลาที่กำหนด. Limit เหล่านี้กำหนดโดย LINE เพื่อควบคุมการใช้งาน API และอาจแตกต่างกันไปตามระดับของบัญชี เช่น บัญชีทดลอง (Developer Trial) อาจมีโควต้า 1,000 requests/min แต่บัญชีธุรกิจอาจมีโควต้าที่แตกต่างกันและสามารถซื้อแพ็กเกจเพิ่มเติมได้เพื่อให้ส่งข้อความได้มากขึ้น
                        <div style={{marginTop: "15px"}}>
                          <strong>เหตุผล</strong>
                          <ol style={{ listStyleType: "decimal"}}>
                            <li>ควบคุมการใช้งาน: เพื่อป้องกันการใช้งานมากเกินไปจนทำให้ระบบมีปัญหา</li>
                            <li>บริหารทรัพยากร: จัดสรรทรัพยากรของเซิร์ฟเวอร์ให้เพียงพอต่อการใช้งานของผู้ใช้ทั้งหมด</li>
                            <li>ข้อจำกัดข้อความฟรี: โดยทั่วไปบัญชีทางการของ LINE จะมีขีดจำกัดข้อความฟรีต่อเดือน ซึ่งจะแตกต่างกันไปตามแพ็กเกจที่เลือก (เช่น แพ็กเกจ Light, แพ็กเกจ Standard) หากเกินขีดจำกัดนี้ ข้อความจะไม่ถูกส่ง และจะมีข้อความตอบกลับ (เช่น ข้อผิดพลาด 403 Forbidden หรือข้อผิดพลาดเฉพาะที่เกี่ยวข้องกับการเกินขีดจำกัดข้อความ)</li>
                          </ol>
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" style={{fontSize: "13px"}} data-bs-dismiss="modal">รับทราบ</button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}

            {user ? (
                              <div className="inputSelectors bgFinder" style={{ marginRight: "0px" }}>
                              <p>
                                <i class="fa-solid fa-magnifying-glass"></i> ค้นหา
                              </p>
                              <input
                                type="search"
                                className="form-control indexInputSR"
                                placeholder="ค้นหา"
                                value={searchQuery} // ใช้ค่า searchQuery เป็น value
                                onChange={(e) => setSearchQuery(e.target.value)} // อัพเดต searchQuery เมื่อผู้ใช้พิมพ์
                                style={{ fontSize: "14px", width: "auto", textAlign: "left" }}
                              />
                            </div>
                ) : (
                  <div></div>
                )}



            {/* start table */}
            <div className={user ? "dataTables" : "dataTables userOnly"}>
              <table className='table' id='tableContent'>
                <thead>
                  <tr>
                    <th>Orders</th>
                    <th>Code</th>
                    <th>Date</th>
                    <th>Description</th>
                    <th style={{textAlign : "left"}}>Picture</th>
                    {/* <th>Phone</th> */}
                    <th>Department</th>
                    <th>Position</th>
                    <th style={{textAlign:"right"}}>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (

                      <tr key={index}>
                        {/* <td>#{index + 1}</td> */}
                        <td>{item.list_index}</td>
                        <td>
                          <div>
                            {item.list_id_type}
                          </div>
                          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                            <div>
                              {(() => {
                                  const listType = Number(item.list_type);

                                  if (isNaN(listType)) {
                                    return <span>ข้อมูลไม่ถูกต้อง</span>; 
                                  }

                                  switch (listType) {
                                    case 1:
                                      return <div className="alertLabelForType"><i class="fa-solid fa-gear"></i> งานช่าง</div>;
                                    case 2:
                                      return <div className="alertLabelForType"><i class="fa-solid fa-headset"></i> IT Support</div>;
                                    case 3:
                                      return <div className="alertLabelForType"><i class="fa-solid fa-code"></i> Programmer</div>;
                                    default:
                                      return <div className="alertLabelForType"><i class="fa-solid fa-user-slash"></i> ไม่ทราบประเภทงาน</div>;
                                  }

                              })()}
                            </div>
                            <div style={{width: "max-content"}}>
                              <button
                                type="button"
                                className="btn"
                                data-bs-toggle="modal"
                                data-bs-target={`#editTypeModal_${item.list_id_type}`}
                                onClick={() => handleOpenTypeModal(item)}
                                style={{fontSize: "13px"}}
                              >
                                <i className="fa-solid fa-pen-to-square"></i> แก้ไข
                              </button>
                            </div>
                          </div>
                          <div style={{marginTop: "10px"}} className="indexListData_a">

                            {/* <NavLink 
                              to={`/repair/list?id=${item.list_id_type}&type=${item.list_type}`} 
                              className='dropdown-item active'
                            >
                              <i class="fa-solid fa-arrow-up-right-from-square"></i> ดูรายการ
                            </NavLink> */}

                            <NavLink
                              to={`/repair/list/${item.list_id_type}?ver=${item.list_type}`}
                              className="dropdown-item active"
                            >
                              <i className="fa-solid fa-arrow-up-right-from-square"></i> ดูรายการ
                            </NavLink>

                          </div>

                          {/* Modal แก้ไขประเภทงาน */}
                          <div
                            className="modal fade"
                            id={`editTypeModal_${item.list_id_type}`}
                            tabIndex="-1"
                            aria-labelledby={`editTypeModalLabel_${item.list_id_type}`}
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id={`editTypeModalLabel_${item.list_id_type}`}>
                                    แก้ไขประเภทงาน
                                  </h5>
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>

                                <div className="modal-body">
                                  {updateTypeMessage[item.list_id_type] && (
                                    <div
                                      className={`alert ${updateTypeMessage[item.list_id_type].type === 'success' ? 'alert-success' : 'alert-danger'}`}
                                      role="alert"
                                    >
                                      {updateTypeMessage[item.list_id_type].message}
                                    </div>
                                  )}

                                  <div className="mb-3 p-3">
                                    <label className="form-label"><i className="fa-solid fa-box"></i> ประเภทงาน</label>
                                    <select
                                      className="form-select"
                                      value={typeEditValues[item.list_id_type] || item.list_type || ""}
                                      onChange={e => handleChangeType(item.list_id_type, e.target.value)}
                                    >
                                      <option value="">-- เลือกประเภทงาน --</option>
                                      <option value="1">งานช่าง</option>
                                      <option value="2">IT Support</option>
                                      <option value="3">Programmer</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="modal-footer">
                                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">ปิด</button>
                                  <button type="button" className="btn btn-primary" onClick={() => updateType(item.list_id_type)}>
                                    <i className="fa-solid fa-rotate-right"></i> Update
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div>
                            {item.list_date_real}
                          </div>
                        </td>
                        <td>
                          <div style={{ width: '240px', display: 'grid' }}>
                            <span style={{ color: '#000000c2', fontWeight: '500', marginBottom: '10px' }}>
                              <i className="fa-solid fa-user"></i> {item.list_username}
                            </span>
                            <span>
                              <i className="fa-solid fa-building"></i> {item.list_company}
                            </span>
                            <div>
                              <i className="fa-solid fa-calendar"></i> {item.list_date_real}
                            </div>
                            <div style={{ marginTop: '15px' }}>
                              <div>
                                <i className="fa-solid fa-circle-exclamation" style={{ color: 'orange' }}></i> เหตุผล{' '}
                              </div>
                              {item.list_reason}
                            </div>
                            <div style={{ marginTop: '15px' }}>
                              {item.list_start && <div><i class="fa-solid fa-calendar"></i> วันที่เริ่มงาน: {item.list_start}</div>}
                              {item.list_end && <div>วันที่สิ้นสุดงาน: {item.list_end}</div>}
                            </div>
<div style={{ marginTop: "15px" }}>
  <p style={{ marginBottom: "0px" }}>
    <i className="fa-solid fa-circle-exclamation" style={{ color: "orange" }}></i> รายละเอียดการซ่อมงาน
  </p>

  {!adminEditMode[item.list_id_type] ? (
    <div
      className="admin-edit-preview"
      onClick={() => {
        setAdminEditMode(prev => ({
          ...prev,
          [item.list_id_type]: true
        }));

        setTimeout(() => {
          const textarea = adminTextareaRefs.current[item.list_id_type];
          if (textarea) {
            textarea.focus();
            const length = textarea.value.length;
            textarea.setSelectionRange(length, length);
          }
        }, 50);
      }}
      title="คลิกเพื่อแก้ไข"
    >
      {adminValues[item.list_id_type] || <span style={{ color: "#aaa" }}>คลิกเพื่อเพิ่มข้อมูล...</span>}
    </div>
  ) : (
    <div style={{ marginTop: "8px" }}>
      <textarea
        ref={(el) => (adminTextareaRefs.current[item.list_id_type] = el)}
        value={adminValues[item.list_id_type] || ""}
        onChange={(e) => handleChangeAdmin(item.list_id_type, e.target.value)}
        placeholder="กรอกรายละเอียดการซ่อมงาน..."
        style={{
          width: "100%",
          minHeight: "90px",
          fontSize: "13px",
          lineHeight: "1.6",
          borderRadius: "10px",
          border: "1px solid #dcdcdc",
          boxShadow: "none",
          outline: "none",
          padding: "12px",
          backgroundColor: "#fff",
          resize: "vertical",
          WebkitAppearance: "none",
          MozAppearance: "none",
          appearance: "none"
        }}
      />

      {adminValues[item.list_id_type]?.trim().length >= 1 && (
        <button
          className="btn btn-primary"
          style={{ fontSize: "13px", marginTop: "10px" }}
          onClick={() => updateAdminNote(item.list_id_type)}
        >
          <i className="fa-solid fa-floppy-disk"></i> บันทึก
        </button>
      )}

      <button
        className="btn btn-light"
        style={{ fontSize: "13px", marginTop: "10px", marginLeft: "8px" }}
        onClick={() =>
          setAdminEditMode(prev => ({
            ...prev,
            [item.list_id_type]: false
          }))
        }
      >
        <i class="fa-solid fa-circle-xmark"></i> ยกเลิก
      </button>
    </div>
  )}

  {adminSaveMessage[item.list_id_type] && (
    <div
      style={{
        marginTop: "8px",
        fontSize: "12px",
        color: adminSaveMessage[item.list_id_type].type === "success" ? "green" : "red"
      }}
    >
      {adminSaveMessage[item.list_id_type].message}
    </div>
  )}
</div>
                          </div>
                        </td>
                        <td>
                          <div>
                          {item.list_img ? (
                              <div style={{textAlign: "left"}}>
                                <a href="#" data-bs-toggle="modal" data-bs-target={`#imageModal${index}`}>
                                  <img
                                    // src={`uploads/${item.list_img}`}
                                    src={`https://software.piyamanee.com/uploads/${item.list_img}`}
                                    alt="รูปภาพ"
                                    fetchPriority="high"
                                    style={{
                                      width: "60px",
                                      height: "60px",
                                      cursor: "pointer",
                                      borderRadius: "10px",
                                    }}
                                    className="listDataImgBox"
                                  />
                                </a>
                              </div>
                            ) : (
                              <div style={{textAlign: "left" , width: "120px" , fontSize: "13px"}}><i class="fa-solid fa-circle-exclamation"></i> ไม่ได้แนบรูปภาพ </div>
                            )}
                          </div>

                          {/* Bootstrap Modal */}
                          <div
                            className="modal fade"
                            id={`imageModal${index}`}
                            tabIndex="-1"
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <div style={{ display: "grid" }}>
                                    <h5 className="modal-title">{item.list_reason}</h5>
                                    <div>
                                      <i className="fa-solid fa-user"></i> ผู้แจ้ง : {item.list_username}
                                    </div>
                                  </div>
                                  <button type="button" className="modal_btnClose" data-bs-dismiss="modal"> <i class="fa-solid fa-circle-xmark"></i> </button>
                                </div>

                                <div className="modal-body text-center">
                                  {/* Add Fancybox link here to show the image in large view */}
                                  <a
                                    href={`https://software.piyamanee.com/uploads/${item.list_img}`} // Link to large image for Fancybox
                                    data-fancybox="gallery" // Use Fancybox to create a gallery of images
                                    data-caption={item.list_reason} // Optional caption for the image
                                  >
                                    <img
                                      src={`https://software.piyamanee.com/uploads/${item.list_img}`}
                                      alt="รูปภาพ"
                                      className="img-fluid"
                                      style={{ maxHeight: "500px", cursor: "pointer" }}
                                    />
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>

                        </td>
                        {/* <td>{item.list_phone}</td> */}
                        <td>{item.list_department}</td>
                        <td>
                          <div style={{width:"150px"}}>{item.list_position}</div>
                        </td>
                        <td>
                          <div>
                        {(() => {
                          switch (item.list_status) {
                            case "Waiting":
                              return (
                                <div
                                  className="alertLabelForStatus"
                                  style={{
                                    background: "rgb(255 165 0 / 13%)",
                                    color: "orange"
                                  }}
                                >
                                  <i className="fa-solid fa-hourglass-start"></i> กำลังรอ
                                </div>
                              );
                            case "Processing":
                              return (
                                <div
                                  className="alertLabelForStatus"
                                  style={{
                                    background: "rgb(77 131 163 / 13%)",
                                    color: "#6c91e3"
                                  }}
                                >
                                  <i className="fa-solid fa-person-running"></i> กำลังดำเนินการ
                                </div>
                              );
                            case "Success":
                              return (
                                <div
                                  className="alertLabelForStatus"
                                  style={{
                                    background: "rgb(77 163 100 / 13%)",
                                    color: "rgb(42 151 55)"
                                  }}
                                >
                                  <i className="fa-solid fa-circle-check"></i> เรียบร้อยแล้ว
                                </div>
                              );
                            case "Cancel":
                              return (
                                <div
                                  className="alertLabelForStatus"
                                  style={{
                                    background: "rgb(163 77 77 / 13%)",
                                    color: "rgb(237 29 29)"
                                  }}
                                >
                                  <i class="fa-solid fa-ban"></i> ยกเลิก
                                </div>
                              );
                            default:
                              return (
                                <div className="alertLabelForStatus">
                                  <i className="fa-solid fa-user-slash"></i> ไม่ทราบประเภทงาน
                                </div>
                              );
                          }
                        })()}

                          {user ? (
                            <div className="dropdown">
                              <button
                                className="btn btn-sm dropdown-toggle buttonSettings"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="fa-solid fa-folder-closed"></i> ปิดงาน
                              </button>

                              <ul className="dropdown-menu dropdown-menu-dark dropdownContent">
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => updateStatus('Success', item.list_id_type)}
                                  >
                                    <i className="fa-solid fa-circle-check"></i> สำเร็จ
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => updateStatus('Processing', item.list_id_type)}
                                  >
                                    <i className="fa-solid fa-person-running"></i> กำลังดำเนินการ
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    onClick={() => updateStatus('Cancel', item.list_id_type)}
                                  >
                                    <i className="fa-solid fa-ban"></i> ผู้แจ้งยกเลิกงาน
                                  </button>
                                </li>
                                <li>
                                  <button
                                    className="dropdown-item"
                                    data-bs-toggle="modal"
                                    data-bs-target={`#editDateModal_${item.list_id_type}`}
                                    onClick={() => handleOpenModal(item)}
                                  >
                                    <i className="fa-solid fa-calendar-days"></i> แก้ไขวันที่
                                  </button>

                                </li>
                              </ul>

                              {/* Modal แก้ไขวันที่ */}
                              <div
                                className="modal fade"
                                id={`editDateModal_${item.list_id_type}`}
                                tabIndex="-1"
                                aria-labelledby="editDateModalLabel"
                                aria-hidden="true"
                              >
                                <div className="modal-dialog modal-dialog-centered">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title" id="editDateModalLabel">
                                        แก้ไขวันที่
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                      ></button>
                                    </div>

                                    <div className="modal-body modal-custom">
                                      {updateStatusMessage[item.list_id_type] && (
                                        <div
                                          className={`alert ${
                                            updateStatusMessage[item.list_id_type].type === "success"
                                              ? "alert-success"
                                              : "alert-danger"
                                          }`}
                                          role="alert"
                                        >
                                          {updateStatusMessage[item.list_id_type].message}
                                        </div>
                                      )}

                                      <div className="mb-3">
                                        <label className="form-label">
                                          <i className="fa-solid fa-calendar"></i> วันที่เริ่มงาน
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          value={dateValues[item.list_id_type]?.start || ""}
                                          onChange={e => handleChangeDate(item.list_id_type, "start", e.target.value)}
                                        />
                                      </div>
                                      <div className="mb-3">
                                        <label className="form-label">
                                          <i className="fa-solid fa-calendar"></i> วันที่สิ้นสุดงาน
                                        </label>
                                        <input
                                          type="date"
                                          className="form-control"
                                          value={dateValues[item.list_id_type]?.end || ""}
                                          onChange={e => handleChangeDate(item.list_id_type, "end", e.target.value)}
                                        />
                                      </div>
                                    </div>

                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                      >
                                        ปิด
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => updateDate(item.list_id_type)}
                                      >
                                        <i className="fa-solid fa-rotate-right"></i> Update
                                      </button>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div></div>
                          )}

<div style={{ marginTop: "22px" }}>
  <div><i className="fa-solid fa-key"></i> รหัสอุปกรณ์ (สำหรับ IT Support)</div>

  <div>
    <textarea
      data-id={item.list_id_type}
      className="form-control listNoteData"
      placeholder="กรอกรหัสอุปกรณ์..."
      name="list_object"
      value={objectValues[item.list_id_type] || ""}
      onChange={(e) => handleChangeObject(item.list_id_type, e.target.value)}
      style={{
        minHeight: "80px",
        resize: "vertical",
        width: "100%",
        maxWidth: "700px",
        fontSize: "11px",
        lineHeight: "1.6",
        padding: "12px",
        borderRadius: "10px",
        marginTop: "8px"
      }}
    />
  </div>

  <button
    className="btn btn-primary"
    style={{ fontSize: "13px", marginTop: "10px" }}
    onClick={() => updateObject(item.list_id_type)}
  >
    <i className="fa-solid fa-upload"></i> บันทึก
  </button>

  {objectSaveMessage[item.list_id_type] && (
    <div
      style={{
        marginTop: "8px",
        fontSize: "12px",
        color: objectSaveMessage[item.list_id_type].type === "success" ? "green" : "red"
      }}
    >
      {objectSaveMessage[item.list_id_type].message}
    </div>
  )}
</div>

                          </div>
                        </td>
                      </tr>

                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" style={{ textAlign: 'center' }}>
                        {/* กำลังโหลดข้อมูล... */}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className={user ? "pagination" : "pagination userOnly"}>
            <div style={{display:"flex" , alignItems: "center"}}>
              <button className="p_onClickPrev" onClick={handlePrevPage} disabled={currentPage === 1}>
                <i class="fa-solid fa-angle-left"></i> ก่อนหน้า
              </button>
              <span className="p_pagesIndex">หน้า {currentPage} ของ {totalPages}</span>
              <button className="p_onClickNext" onClick={handleNextPage} disabled={currentPage === totalPages}>
                ต่อไป <i class="fa-solid fa-angle-right"></i>
              </button>
            </div>
            <div className="p_indexIndicator" style={{fontSize: "14px" , marginLeft: "10px"}}>
              หน้าละ 10 รายการ
            </div>
          </div>

          <div className="loader" style={{ display: "none" }}>
            <div className="spinner"></div>
          </div>

          <div id="alertSuccess">
          </div>

          {user ? (
              <div></div>
          ) : (
              <div className="adminOnlyAlert">
                 <span>
                  <span><i class="fa-solid fa-lock"></i> Do not access data without permission</span> <span>สำหรับพนักงานที่มีรหัสเท่านั้น</span> <br/> <Link to='/login'><i class="fa-solid fa-arrow-right"></i> Back to Login</Link>
                 </span>
              </div>
          )}

        </div>

    </main>
    
  )
}

export default Repair